import React from "react";
import { altColor } from "../../utils/constants";

export default function IconImages({ color = altColor }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 504.9 512">
      <g id="Ebene_2" data-name="Ebene 2">
        <g id="Ebene_1-2" data-name="Ebene 1">
          <path
            d="M350.13,144.91H56.86a10,10,0,0,0-10,10V451.5a10,10,0,0,0,10,10H350.13a10,10,0,0,0,10-10V154.91a10,10,0,0,0-10-10Zm-283.27,20H340.13V311H302.46a136.18,136.18,0,0,0-110.77,56.36,95.35,95.35,0,0,0-46.08-11.77h-2.83a95.79,95.79,0,0,0-75.92,37.36ZM340.13,441.19H67.56a76,76,0,0,1,75.22-65.61h2.83a75.4,75.4,0,0,1,43.28,13.54,10,10,0,0,0,14.2-2.93A116.44,116.44,0,0,1,302.46,331h37.67v110.2Z"
            fill={color}
          />
          <path
            d="M159.91,306.82a48.07,48.07,0,1,0-48.07-48.06A48.11,48.11,0,0,0,159.91,306.82Zm0-76.13a28.07,28.07,0,1,1-28.07,28.07A28.1,28.1,0,0,1,159.91,230.69Z"
            fill={color}
          />
          <path
            d="M498.08,70.73a36.47,36.47,0,0,0-23.81-14.91L145.32.52A36.72,36.72,0,0,0,103,30.63L92.36,94.1H36.71A36.75,36.75,0,0,0,0,130.81V475.29A36.75,36.75,0,0,0,36.71,512H370.28A36.75,36.75,0,0,0,407,475.29V439.78s7.36,1.14,9.41,1.14a36.71,36.71,0,0,0,36.13-30.65L504.38,98.11a36.44,36.44,0,0,0-6.3-27.38ZM387,475.29A16.73,16.73,0,0,1,370.28,492H36.71A16.73,16.73,0,0,1,20,475.29V130.81A16.73,16.73,0,0,1,36.71,114.1H370.28A16.73,16.73,0,0,1,387,130.81V475.29ZM484.66,94.81,432.8,407a16.71,16.71,0,0,1-19.14,13.73L407,419.41V130.81A36.75,36.75,0,0,0,370.28,94.1H112.64L122.75,34A16.72,16.72,0,0,1,142,20.24L471,75.55a16.71,16.71,0,0,1,13.71,19.26Z"
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
}
